if (typeof GiftBoxCartHandler === 'undefined') {
  class GiftBoxCartHandler {
    constructor() {
      this.init();
    }

    init() {
      document.addEventListener('click', (e) => {
        const removeBtn = e.target.closest('[data-action="remove-bundle"]');
        if (removeBtn) this.removeBundle(removeBtn.dataset.bundleId);
      });
    }

    async removeBundle(bundleId) {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      const updates = {};
      
      cart.items.forEach(item => {
        if (item.properties && item.properties._bundle_id === bundleId) {
          updates[item.key] = 0;
        }
      });

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({ updates })
      });
      window.location.reload();
    }
  }
  new GiftBoxCartHandler();
  window.GiftBoxCartHandler = true;
}